var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8.4,
    viewBox: "0 0 14 8.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-bold",
    transform: "translate(18.03 -15.002) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38921",
    "data-name": "Path 38921",
    d: "M15.323,4.338a1.021,1.021,0,0,0,0,1.487l5.43,5.205-5.43,5.205a1.021,1.021,0,0,0,0,1.487,1.131,1.131,0,0,0,1.551,0l6.206-5.949a1.021,1.021,0,0,0,0-1.487L16.874,4.338A1.131,1.131,0,0,0,15.323,4.338Z",
    transform: "translate(0)",
    fill: "#0267c1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBold);
export default __webpack_public_path__ + "static/media/arrow-right-bold.1ca1c1c57c1699a21b7bfc446caf8e3d.svg";
export { ForwardRef as ReactComponent };